import { useGeckoLocale } from 'features/locale/GeckoLocaleProvider'
import { useSelectedOrgAndSiteInterface } from 'features/orgAndSiteSourceOfTruth'
import { useRolodexEntries } from 'features/rolodex'
import { useEffect, useMemo } from 'react'
import { RolodexEntryType } from 'types'

export function useSiteLanguageDefault(): void {
  const { getSiteId } = useSelectedOrgAndSiteInterface()
  const siteId = getSiteId()
  const { setDefaultLanguage } = useGeckoLocale()
  const query = useMemo(
    () =>
      siteId
        ? {
            type: [RolodexEntryType.SITE_CONFIG],
            tags: { site: siteId },
            limit: 1,
          }
        : undefined,
    [siteId]
  )
  const { siteConfigs } = useRolodexEntries(query)
  const siteLanguage = siteConfigs.find((config) => config.tags.site === siteId)
    ?.data.language

  useEffect(() => {
    setDefaultLanguage(siteLanguage ?? 'en')
  }, [siteId, siteLanguage, setDefaultLanguage])
}
